/* global $ */
import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import Swal from 'sweetalert2';

function Searchbill() {
    const [registrationno, setRegistrationno] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [data, setData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [searchText, setSearchText] = useState('');

    const handleClear = () => {
        setRegistrationno('');
        setData([]);
        setStartDate('');
        setEndDate('');
    };


    const handleSearch = async (e) => {
        e.preventDefault();

        // Ensure dates are provided
        if (!startDate || !endDate) {
            Swal.fire('Error!', 'Please select the date range to search bills', 'error');
            return;
        }

        try {
            const response = await axios.get(`https://api.sivammoto.in/api/searchbuyer/search-by-dates`, {
                params: {
                    from_date: startDate, // The from date selected by the user
                    to_date: endDate      // The to date selected by the user
                }
            });
            console.log(response.data)

            setData(response.data);
        } catch (error) {
            console.error('Error fetching vehicle registraion number data', error);
            const errorMessage = error.response?.data?.error || error.response?.data?.message || error.response?.statusText || 'An unknown error occurred';
            Swal.fire('Error!', `There was an issue in searching the registration records: ${errorMessage}`, 'error');
        }
    };

    const printBill = async (row) => {
        setSelectedRow(row);
        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to Print this bill?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Print it!',
        });
        if (result.isConfirmed) {
            const printContents = document.getElementById("download_section").innerHTML;
            const originalContents = document.body.innerHTML;

            document.body.innerHTML = printContents;  // Replace body content with invoice
            window.print();  // Trigger the print dialog
            document.body.innerHTML = originalContents;
            window.location.reload(); // Ensure styles and scripts are reapplied
        }
    };

    const printBillWithFiles = async (row) => {
        setSelectedRow(row);

        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to Print this bill?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Print it!',
        });

        if (result.isConfirmed) {
            // Store original content
            const originalContents = document.body.innerHTML;

            // Create a temporary container div
            const tempContainer = document.createElement('div');

            // Copy the download_section as is
            tempContainer.innerHTML = document.getElementById("download_section").innerHTML;

            // Create a div to hold the images
            const imagesDiv = document.createElement('div');
            imagesDiv.style.marginTop = "20px";

            // Function to convert an image URL to a base64 string
            const loadImageAsBase64 = (url) => {
                return new Promise((resolve, reject) => {
                    // Create a new image element
                    const img = new Image();
                    img.crossOrigin = "Anonymous"; // Try to handle CORS

                    img.onload = () => {
                        // Create a canvas to draw the image
                        const canvas = document.createElement('canvas');
                        canvas.width = img.width;
                        canvas.height = img.height;

                        // Draw the image on the canvas
                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0);

                        // Get the base64 data
                        try {
                            const dataURL = canvas.toDataURL('image/png');
                            resolve(dataURL);
                        } catch (e) {
                            // If we can't get dataURL (e.g., CORS issues), just use the original URL
                            resolve(url);
                        }
                    };

                    img.onerror = () => {
                        console.error(`Failed to load image: ${url}`);
                        resolve(null); // Resolve with null to allow other images to continue
                    };

                    img.src = url;
                });
            };

            // Load all images, convert to base64 if possible
            const fileUrls = [
                row.files?.aadhar_file?.url,
                row.files?.rc_file?.url,
                row.files?.photowithbike_file?.url
            ].filter(url => url);

            try {
                // Show loading indicator
                Swal.fire({
                    title: 'Preparing print...',
                    text: 'Loading images, please wait...',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                // Wait for all images to load
                for (let i = 0; i < fileUrls.length; i++) {
                    const fileUrl = fileUrls[i];
                    try {
                        // Try to get base64 version (helps with cross-origin issues)
                        const imgData = await loadImageAsBase64(fileUrl);

                        if (imgData) {
                            const imgElement = document.createElement('img');
                            imgElement.src = imgData;
                            imgElement.style.maxWidth = "100%";
                            imgElement.style.marginTop = "15px";
                            imgElement.style.pageBreakInside = "avoid";
                            imgElement.alt = `File ${i + 1}`;

                            imagesDiv.appendChild(imgElement);
                        }
                    } catch (err) {
                        console.error(`Error processing image ${fileUrl}:`, err);
                    }
                }

                // Append images div to the temp container
                tempContainer.appendChild(imagesDiv);

                // Close loading indicator
                Swal.close();

                // Replace body content with our prepared content
                document.body.innerHTML = tempContainer.innerHTML;

                // Add print styling
                const style = document.createElement('style');
                style.textContent = `
                    @media print {
                        img { max-width: 100%; page-break-inside: avoid; }
                        @page { margin: 1cm; }
                    }
                `;
                document.head.appendChild(style);

                // Print with a small delay to ensure rendering
                setTimeout(() => {
                    window.print();

                    // After printing, restore the original content
                    document.body.innerHTML = originalContents;
                    window.location.reload(); // Ensure styles and scripts are reapplied
                }, 300);
            } catch (error) {
                console.error("Error during print preparation:", error);
                Swal.fire('Error', 'There was an error preparing the print', 'error');
                document.body.innerHTML = originalContents;
                window.location.reload(); // Ensure styles and scripts are reapplied
            }
        }
    };

    const handleEdit = async (row) => {

        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to View this bill?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, view it!',
        });

        if (result.isConfirmed) {
            setSelectedRow(row);

            $('#editRowModal').modal('show');
        }
    };

    // const openaadhar = (row) => {
    //     const fileUrl = row.files?.aadhar_file?.url;
    //     if (fileUrl) {
    //         window.open(fileUrl, "_blank"); // Opens the file in a new tab
    //     } else {
    //         alert("Aadhar file not available.");
    //     }
    // };

    // const openrc = (row) => {
    //     const fileUrl = row.files?.rc_file?.url;
    //     if (fileUrl) {
    //         window.open(fileUrl, "_blank"); // Opens the file in a new tab
    //     } else {
    //         alert("RC Book file not available.");
    //     }
    // };

    // const openphoto = (row) => {
    //     const fileUrl = row.files?.photowithbike_file?.url;
    //     if (fileUrl) {
    //         window.open(fileUrl, "_blank"); // Opens the file in a new tab
    //     } else {
    //         alert("Photo not available.");
    //     }
    // };


    const filteredData = data.filter(item =>
        (String(item.ref_reg_no).toLowerCase().includes(searchText.toLowerCase())) ||
        item.billing_details.date.toLowerCase().includes(searchText.toLowerCase()) ||
        item.billing_details.to_name.toLowerCase().includes(searchText.toLowerCase()) ||
        item.billing_details.cash_paid1.toLowerCase().includes(searchText.toLowerCase()) ||
        item.billing_details.to_phone1.toLowerCase().includes(searchText.toLowerCase()) ||
        item.billing_details.bike_model.toLowerCase().includes(searchText.toLowerCase())
    );



    const columns = [
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>No</span>,
            selector: (row, index) => index + 1,
            sortable: true,
            width: '60px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Registration No</span>,
            selector: row => row.ref_reg_no || "",
            sortable: true,
            width: '180px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Bill Date</span>,
            selector: row => {
                if (!row.billing_details?.date) return ""; // Handle empty dates

                const date = new Date(row.billing_details.date);
                return date.toLocaleDateString("en-GB"); // Formats as DD/MM/YYYY
            },
            sortable: true,
            width: '180px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Buyer Name</span>,
            selector: row => row.billing_details?.to_name || "",
            sortable: true,
            width: '180px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Amount</span>,
            selector: row => row.billing_details?.cash_paid1 || "",
            sortable: true,
            width: '180px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Phone</span>,
            selector: row => row.billing_details?.to_phone1 || "",
            sortable: true,
            width: '180px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Model</span>,
            selector: row => row.billing_details?.bike_model || "",
            sortable: true,
            width: '180px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Actions</span>,
            cell: row => (
                <div>
                    <button onClick={() => handleEdit(row)} className="btn btn-primary btn-sm" style={{ marginRight: '8px' }}>
                        <i className="fa fa-eye"></i>
                    </button>
                    <button onClick={() => printBillWithFiles(row)} className="btn btn-secoundary btn-sm" style={{ marginRight: '8px' }}>
                        <i className="fa fa-user"></i>
                    </button>
                    <button onClick={() => printBill(row)} className="btn btn-success btn-sm" style={{ marginRight: '8px' }}>
                        <i className="fa fa-print"></i>
                    </button>
                </div>
            ),
            width: '250px'
        }
    ];


    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Search Bill</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Search Bill</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-8">
                    <form onSubmit={handleSearch}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                            }
                        }}>
                        <div className="row">
                            <div className="col-md-12 offset-md-1">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="row align-items-center">
                                            <div className="col-md-3">
                                                <label>From Date:</label>
                                            </div>
                                            <div className="col-md-9">
                                                <input type="date" className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-6">
                                        <div className="row align-items-center">
                                            <div className="col-md-3">
                                                <label>To Date:</label>
                                            </div>
                                            <div className="col-md-9">
                                                <input type="date" className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-6"></div>
                                    <div className="col-md-6">
                                        <div className="form-group align-items-center">
                                            <button className="btn btn-primary mr-2">Search</button>
                                            <button
                                                className="btn btn-secondary"
                                                type="button"
                                                onClick={handleClear}
                                            >
                                                Clear
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            {data && (
                <div className="row mb-2 mt-2">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    className="form-control mb-3"
                                />
                                <DataTable
                                    columns={columns}
                                    data={filteredData}
                                    pagination
                                    paginationPerPage={100}  // Set number of rows per page
                                    paginationRowsPerPageOptions={[100, 200, 300, 400]}
                                />

                                {/* Edit Modal */}
                                <div className="modal fade" id="editRowModal">
                                    <div className="modal-dialog modal-xl">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title">Bill</h4>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                {/* School Fee Bill */}
                                                {selectedRow && selectedRow.billing_details && Object.keys(selectedRow.billing_details).length > 0 && (
                                                    <div className="delivery-note-container">
                                                        <div className="delivery-note-header">
                                                            <img src="dist/img/shivam.jpeg" alt="Shivam Moto Banner" className="header-image" />
                                                        </div>

                                                        <div className="delivery-note-section">
                                                            {/* Left Section for DN No. and Date */}
                                                            <div className="delivery-note-left">
                                                                <p><strong>Bill No:</strong>{selectedRow.billing_id || ""}</p>
                                                                <p><strong>Date:</strong>{selectedRow.billing_details.date || ""}</p>
                                                            </div>

                                                            <div className="delivery-note-header">
                                                                <h3 className="delivery-note-title"><strong>DELIVERY NOTE</strong></h3>
                                                                <h3 className="delivery-note-title1">ONLY ON COMMISSION BASIS</h3>
                                                            </div>


                                                            {/* Right Section for Image */}
                                                            <div className="delivery-note-image">
                                                                <div className="delivery-note-image-container">
                                                                    <img src={selectedRow?.files?.photo_file?.url || ""} alt="Buyer" className="fixed-image" />
                                                                </div>
                                                            </div>

                                                        </div>

                                                        <div className="delivery-note-info">
                                                            <div>
                                                                <h3 className="delivery-note-fromto"><span className="highlight-text">From</span>:</h3>
                                                                <p>{selectedRow.billing_details.from_name || ""}</p>
                                                                <p>{selectedRow.billing_details.from_address1 || ""}</p>
                                                                <p>{selectedRow.billing_details.from_address2 || ""}</p>
                                                                <p>{selectedRow.billing_details.from_city || ""}</p>
                                                            </div>
                                                            <div>
                                                                <h3 className="delivery-note-fromto"><span className="highlight-text">To</span>:</h3>
                                                                <p>{selectedRow.billing_details.to_name}</p>
                                                                <p>{selectedRow.billing_details.to_address1}</p>
                                                                <p>{selectedRow.billing_details.to_address2}</p>
                                                                <p>{selectedRow.billing_details.to_city}</p>
                                                                <p>
                                                                    <strong>Phone:</strong> {selectedRow.billing_details.to_phone1}, {selectedRow.billing_details.to_phone2}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div className="delivery-note-right-align">
                                                            <p><strong>Sir,</strong></p>
                                                            <div className="letter-content">
                                                                <p><span className="highlight-text"><strong>Ref:</strong> {selectedRow.ref_reg_no} / {selectedRow.billing_details.ref_vehicle_type} {selectedRow.billing_details.ref_vehicle_color}</span></p>
                                                                <p>
                                                                    I have this day purchased the above vehicle from you for the sum of Rs.<strong> {selectedRow.billing_details.ref_amount}</strong> (Rupees in Words: <strong> {selectedRow.billing_details.ref_amountinwords}</strong>) and I have taken the delivery of the said vehicle to my entire satisfaction.
                                                                </p>
                                                                <p>
                                                                    The entire risk is being bome by me / us / from this time <strong>{selectedRow.billing_details.ref_time}</strong>
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div className="delivery-note-row">
                                                            {/* Left: Vehicle Details */}
                                                            <div className="delivery-note-vehicle-details">
                                                                <h3 className="delivery-note-fromto"><mark className="highlight-text">Vehicle Details</mark></h3>
                                                                <p><strong>Model:</strong><span>{selectedRow.billing_details.bike_model}</span></p>
                                                                <p><strong>Make:</strong><span>{selectedRow.billing_details.bike_make}</span></p>
                                                                <p><strong>Color:</strong> <span>{selectedRow.billing_details.bike_color}</span></p>
                                                                <p><strong>Chase No:</strong> <span>{selectedRow.billing_details.bike_chase_no}</span></p>
                                                                <p><strong>Engine No:</strong> <span>{selectedRow.billing_details.bike_engine_no}</span></p>
                                                                <p><strong>Bank Name:</strong> <span>{selectedRow.billing_details.bank_name}</span></p>
                                                            </div>

                                                            {/* Right: Payment Details */}
                                                            <div className="delivery-note-payment">
                                                                <h3 className="delivery-note-fromto"><mark className="highlight-text">Payment Details</mark></h3>
                                                                <p><strong>1) Payment Type:</strong><span> {selectedRow.billing_details.payment_type1}  /  {selectedRow.billing_details.cash_paid1}</span></p>
                                                                <p><strong>2) Payment Type:</strong><span> {selectedRow.billing_details.payment_type2}  /  {selectedRow.billing_details.cash_paid2}</span></p>
                                                                <p><strong>Balance:</strong><span>{selectedRow.billing_details.balance}</span> </p>
                                                                <p><strong>Finance:</strong><span> {selectedRow.billing_details.finance}</span></p>
                                                                <p><strong>EMI / Tenure:</strong><span>{selectedRow.billing_details.emi_tenure}</span></p>
                                                            </div>
                                                        </div>
                                                        <h3 className="delivery-note-fromto">Exchange Details</h3>
                                                        <div className="delivery-note-row">

                                                            {/* Left: Vehicle Details */}
                                                            <div className="delivery-note-vehicle-details">
                                                                <p><strong>Exchange Of:</strong><span>{selectedRow.billing_details.exchange_of}</span></p>
                                                                <p><strong>Amount:</strong><span>{selectedRow.billing_details.exchange_amout}</span></p>
                                                                <p><strong>Chase No:</strong> <span>{selectedRow.billing_details.exchange_bike_chase_no}</span></p>
                                                                <p><strong>Engine No:</strong> <span>{selectedRow.billing_details.exchange_bike_engine_no}</span></p>
                                                            </div>

                                                            {/* Right: Payment Details */}
                                                            <div className="delivery-note-payment">
                                                                <p><strong>Model:</strong><span>{selectedRow.billing_details.exchange_bike_model}</span></p>
                                                                <p><strong>Reg No:</strong><span>{selectedRow.billing_details.exchange_reg_no}</span></p>
                                                                <p><strong>Make:</strong> <span>{selectedRow.billing_details.exchange_bike_make}</span></p>
                                                                <p><strong>Color:</strong> <span>{selectedRow.billing_details.exchange_bike_color}</span></p>
                                                            </div>
                                                        </div>

                                                        <div className="delivery-note-tamil-text">
                                                            <p><i className="fa fa-check-square"></i> இந்த வண்டியை தற்பொழுது இருக்கும் நிலையில் வாங்க சம்மதிக்கிறேன்.</p>
                                                            <p><i className="fa fa-check-square"></i> எந்த வித ரிப்பேர் செலவு வந்தாலும் நிர்வாகம் பொறுப்பல்ல.</p>
                                                            <p><i className="fa fa-check-square"></i> வண்டியை எடுத்துச் சென்ற பின் எந்தவித காரணத்தை கொண்டும் திருப்பி எடுத்துக் கொள்ளப்பட மாட்டாது.</p>
                                                            <p><i className="fa fa-check-square"></i> வண்டி வாங்கிய 15 நாட்களுக்குள் பெயர் மாற்றிக்கொள்ள வேண்டும்.</p>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/*Print Bill*/}
            {selectedRow && (
                <div id="download_section" style={{ display: "none" }}>
                    {selectedRow && selectedRow.billing_details && Object.keys(selectedRow.billing_details).length > 0 && (

                        <div className="delivery-note-container">
                            <div className="delivery-note-header">
                                <img src="dist/img/shivam.jpeg" alt="Shivam Moto Banner" className="header-image" />
                            </div>

                            <div className="delivery-note-section">
                                {/* Left Section for DN No. and Date */}
                                <div className="delivery-note-left">
                                    <p><strong>Bill No:</strong>{selectedRow.billing_id}</p>
                                    <p><strong>Date:</strong>{selectedRow.billing_details.date}</p>
                                </div>

                                <div className="delivery-note-header">
                                    <h3 className="delivery-note-title"><strong>DELIVERY NOTE</strong></h3>
                                    <h4 className="delivery-note-title1">ONLY ON COMMISSION BASIS</h4>
                                </div>


                                {/* Right Section for Image */}
                                <div className="delivery-note-image">
                                    <div className="delivery-note-image-container">
                                        <img src={selectedRow?.files?.photo_file?.url || ""} alt="Buyer" className="fixed-image" />
                                    </div>
                                </div>

                            </div>

                            <div className="delivery-note-info">
                                <div>
                                    <h3 className="delivery-note-fromto"><span className="highlight-text">From</span>:</h3>
                                    <p><strong><b>{selectedRow.billing_details.from_name}</b></strong></p>
                                    <p>{selectedRow.billing_details.from_address1}</p>
                                    <p>{selectedRow.billing_details.from_address2}</p>
                                    <p>{selectedRow.billing_details.from_city}</p>
                                </div>
                                <div>
                                    <h3 className="delivery-note-fromto"><span className="highlight-text">To</span>:</h3>
                                    <p><strong><b>{selectedRow.billing_details.to_name}</b></strong></p>
                                    <p>{selectedRow.billing_details.to_address1}</p>
                                    <p>{selectedRow.billing_details.to_address2} , {selectedRow.billing_details.to_city}</p>
                                    <p></p>
                                    <p>
                                        <strong>Phone:</strong> <strong><b>{selectedRow.billing_details.to_phone1}, {selectedRow.billing_details.to_phone2}</b></strong>
                                    </p>
                                </div>
                            </div>

                            <div className="delivery-note-right-align">
                                <p><strong>Sir,</strong></p>
                                <div className="letter-content">
                                    <p><span className="highlight-text"><strong>Ref:</strong><strong><b> {selectedRow.ref_reg_no} </b></strong>/ {selectedRow.billing_details.ref_vehicle_type} {selectedRow.billing_details.ref_vehicle_color}</span></p>
                                    <p>
                                        I have this day purchased the above vehicle from you for the sum of Rs.<strong> <b>{selectedRow.billing_details.ref_amount}</b></strong> (Rupees in Words: <strong> {selectedRow.billing_details.ref_amountinwords}</strong>) and I have taken the delivery of the said vehicle to my entire satisfaction.
                                    </p>
                                    <p>
                                        The entire risk is being bome by me / us / from this time <strong><b>{selectedRow.billing_details.ref_time}</b></strong>
                                    </p>
                                </div>
                            </div>

                            <div className="delivery-note-row">
                                {/* Left: Vehicle Details */}
                                <div className="delivery-note-vehicle-details">
                                    <h3 className="delivery-note-fromto"><mark className="highlight-text">Vehicle Details</mark>:</h3>
                                    <p><strong>Make:</strong><span>{selectedRow.billing_details.bike_make}</span></p>
                                    <p><strong>Chase No:</strong> <span>{selectedRow.billing_details.bike_chase_no}</span></p>
                                    <p><strong>Engine No:</strong> <span>{selectedRow.billing_details.bike_engine_no}</span></p>
                                    <p><strong>EMI / Tenure:</strong><span>{selectedRow.billing_details.emi_tenure}</span></p>
                                    <p><strong>Exchange Of:</strong><span><strong><b>{selectedRow.billing_details.exchange_of}</b></strong></span></p>
                                </div>

                                {/* Right: Payment Details */}
                                <div className="delivery-note-payment">
                                    <h3 className="delivery-note-fromto"><mark className="highlight-text">Payment Details</mark>:</h3>
                                    <p><strong>1) Payment Type:</strong><span>{selectedRow.billing_details.cash_paid1} / {selectedRow.billing_details.payment_type1}</span></p>
                                    <p><strong>2) Payment Type:</strong><span>{selectedRow.billing_details.cash_paid2} / {selectedRow.billing_details.payment_type2}</span></p>
                                    <p><strong>Exchange Amount:</strong><span>{selectedRow.billing_details.exchange_amout}</span></p>
                                    <p><strong>Balance:</strong><span>{selectedRow.billing_details.balance}</span> </p>
                                    <p><strong>Finance:</strong><span> {selectedRow.billing_details.finance}</span></p>
                                    <p><strong>Bank Name:</strong> <span>{selectedRow.billing_details.emi_tenure}</span></p>
                                </div>
                            </div>

                            <div className="delivery-note-tamil-text">
                                <p><i className="fa fa-check-square"></i> இந்த வண்டியை தற்பொழுது இருக்கும் நிலையில் வாங்க சம்மதிக்கிறேன்.</p>
                                <p><i className="fa fa-check-square"></i> எந்த வித ரிப்பேர் செலவு வந்தாலும் நிர்வாகம் பொறுப்பல்ல.</p>
                                <p><i className="fa fa-check-square"></i> வண்டியை எடுத்துச் சென்ற பின் எந்தவித காரணத்தை கொண்டும் திருப்பி எடுத்துக் கொள்ளப்பட மாட்டாது.</p>
                                <p><i className="fa fa-check-square"></i> வண்டி வாங்கிய 15 நாட்களுக்குள் பெயர் மாற்றிக்கொள்ள வேண்டும்.</p>
                            </div>

                            <div className="delivery-note-signatures">
                                <div>
                                    <p>
                                        <strong>Signature of Dealer</strong>
                                    </p>
                                </div>
                                <div>
                                    <p>
                                        <strong>Signature of Buyer</strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

export default Searchbill